import { Components, Theme } from '@mui/material/styles';

const MuiFormControlLabel: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      marginLeft: theme.spacing(-1),
    }),
  },
};

export default MuiFormControlLabel;
